import React from 'react';
import { Activity } from 'lucide-react';
export function Footer() {
  return <footer className="bg-slate-900 text-slate-300 py-16" data-id="element-203">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-204">
        <div className="max-w-md mb-12" data-id="element-205">
          <div className="flex items-center gap-2 mb-6" data-id="element-206">
            <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-[#FF6B35] to-[#FF8E53] flex items-center justify-center text-white" data-id="element-207">
              <Activity className="w-5 h-5" data-id="element-208" />
            </div>
            <span className="text-xl font-bold text-white" data-id="element-209">ActiveTally</span>
          </div>
          <p className="text-sm leading-relaxed text-slate-400" data-id="element-210">
            Modernizing fitness reimbursement programs with real-time data,
            automation, and seamless member experiences.
          </p>
        </div>

        <div className="pt-8 border-t border-slate-800" data-id="element-211">
          <p className="text-sm text-slate-500" data-id="element-212">
            © {new Date().getFullYear()} ActiveTally Inc. All rights reserved.
          </p>
        </div>
      </div>
    </footer>;
}